import './Report.css';

import { Button, Modal } from 'react-bootstrap';
import React, { useContext, useEffect, useState } from "react";

import DatePicker from 'react-datepicker2';
import { MainContext } from "../store/mainContext";
import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";

export default function ChangeProfile({ show, handleClose }) {
    const [showIng, setShowIng] = useState(false);
    const [form, setForm] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isPosting,setIsPosting] = useState(false);


    const handleCloseIng = () => {
        setShowIng(false);
        handleClose(null);
    }

    useEffect(() => {
        setShowIng(show);
        if (show)
          GetProfile();
    }, [show]);

    


    const GetProfile = async () => {
        //e.preventDefault();
        
        setIsLoading(true);
        const response = await noronServices.GetProfile()
            .then(({ data }) => {
                setIsLoading(false); 
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                setForm(data.payload);
            })
            .catch(err => {
                setIsLoading(false); 
            });
    }    

    const handlePost = async (e) => {
        e.preventDefault();
        
        setIsPosting(true);
        const response = await noronServices.ChangeProfile(form)
            .then(({ data }) => {
                setIsPosting(false); 
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                handleClose(form);
            })
            .catch(err => {
                setIsPosting(false); 
            });
    }

    


    return (
        <>

            <Modal show={showIng} onHide={handleCloseIng} id="modalPatient" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="colorRed">تغییر اطلاعات حساب کاربری
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {isLoading &&
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>}
                    <div className="container">
                        <div className="form-floating mb-3">
                            <input asp-for="name"
                                type="text"
                                name="name" 
                                value={form.name}
                                 onChange={e => http.handleChange(e, form, setForm)}

                                className="form-control" placeholder="نام و نام خانوادگی" autoComplete="off" />
                            <label asp-for="name">نام و نام خانوادگی</label>
                            <span asp-validation-for="name" className="text-danger"></span>
                        </div>
                        <div className="form-floating mb-3">
                            <input asp-for="mobile"
                                type="number"
                                name="mobile"
                                disabled={true}
                                value={form.mobile}
                                 onChange={e => http.handleChange(e, form, setForm)}

                                className="form-control" placeholder="شماره همراه" autoComplete="off" />
                            <label asp-for="mobile">شماره همراه</label>
                            <span asp-validation-for="mobile" className="text-danger"></span>
                        </div>
                       
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" className="col btn btn-success btn-block myCustomButton"
                        onClick={handlePost}
                        disabled={isPosting || isLoading}>
                        {isPosting &&
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>}
                        <span>&nbsp;&nbsp;&nbsp;تایید </span>
                    </Button>
                    <Button variant="danger" className="col btn btn-danger myCustomButton" data-bs-dismiss="modal"
                        onClick={handleCloseIng}>
                        <span>&nbsp;&nbsp;&nbsp;انصراف</span>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );

}
